<template>
  <div>
    <div v-if="eventsAction.length == 0">
      <div class="col-xs-12">
        <p>You currently don't have any events associated to your account.</p>
      </div>
    </div>

    <!-- EVENT LOOP -->
    <div
      v-for="event in eventsAction"
      :key="event.event_number"
      class="row pt-3 pb-3 border-bottom"
    >
      <div class="col-12 row">
        <div>
          <label class="small col-12">Date/Time: {{event.created_ts}}</label>
        </div>

        <div>
          <label class="small col-12">Location: {{event.site_name}}</label>
        </div>
      </div>

      <div class="col row">
        <div
          v-for="camera of event.cameraData"
          :key="camera.cameraNum"
          :class="getColumnGridNum(event.num_devices)"
        >
          <div>
            <label class="small">Camera #{{camera.cameraNum}}</label>
          </div>

          <div class="embed-responsive embed-responsive-16by9">
            <video controls>
              <source :src="camera.url" type="video/mp4" />
              {{event.site_name}} Camera #{{camera.cameraNum}}
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "displayEvents",
  data() {
    return {};
  },
  computed: {
    ...mapState(["endpoint", "events"]),
    endpoint: function() {
      return this.endpoint;
    },
    eventsAction: {
      get: function() {
        return this.events;
      }
    }
  },
  mounted() {
    this.getEvents();
  },
  methods: {
    getColumnGridNum: function(num) {
      if (num <= 2) {
        return "col col-sm-6";
      }
      return "col col-sm-4";
    },

    async getEvents() {
      await this.$store.dispatch("getEvents");
    }
  }
};
</script>